// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchSidebar_container__35Jww","top":"SearchSidebar_top__7c1uF","closeButton":"SearchSidebar_closeButton__127Zz","search":"SearchSidebar_search__1HP9P"};